// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import useValidateForm from '@Hooks/useValidateForm';
import { SSOForm, SSOInput } from './SSOForm';

interface SSOManageProps {
    defaultValues?: SSOInput;
    triggerElem?: ReactElement;
    onFinish: (task: SSOInput) => Promise<any>;
    visible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
    needDueDate?: boolean;
    forbiddenNames?: string[];
}

export const SSOManage = ({
    defaultValues,
    triggerElem,
    onFinish,
    visible,
    onVisibleChange,
    forbiddenNames = [],
}: SSOManageProps): ReactElement => {
    const i = useLocalMessage();
    const { form, isValid, onFormValuesChange, fieldsTouched, setFieldsTouched } = useValidateForm();

    return (
        <THDrawer
            title={
                defaultValues
                    ? i('configPlateform.sso.provider.drawer.edit.title')
                    : i('configPlateform.sso.provider.drawer.add.title')
            }
            triggerElem={triggerElem}
            className="drawer-form"
            visible={visible}
            afterVisibleChange={(visible) => {
                form.resetFields();
                onVisibleChange?.(visible);
            }}
            disableClose={fieldsTouched}
        >
            {(toggleDrawer) => (
                <SSOForm
                    forbiddenNames={forbiddenNames}
                    onFinish={({ another, ...values }) => {
                        onFinish(values as SSOInput).then(() => {
                            if (!another) {
                                toggleDrawer();
                                return;
                            }

                            form.resetFields();
                            onFormValuesChange();
                            setFieldsTouched(false);
                        });
                    }}
                    form={form}
                    defaultValues={defaultValues}
                    onChange={() => {
                        onFormValuesChange();
                        setFieldsTouched(true);
                    }}
                    isValid={isValid && fieldsTouched}
                    onCancel={() => {
                        toggleDrawer();
                        form.resetFields();
                        setFieldsTouched(false);
                    }}
                />
            )}
        </THDrawer>
    );
};
